import { CanMatchFn } from '@angular/router';
import { environment } from '@environment';

export const ecomCashoutSetecomTestGuard: CanMatchFn = () =>
  environment.ecomCashoutSetecomTestEnabled;
